import { useEffect } from "react";
import { useFragment } from "react-relay";
import graphql from "babel-plugin-relay/macro";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import ReactGA from "react-ga4";

function ProjectCardLarge({ projectRef }) {
    const project = useFragment(
        graphql`
            fragment ProjectCardLarge_project on Project {
                title
                content
                image
            }
        `,
        projectRef
    );

    const navigate = useNavigate();

    useEffect(() => {
        document.title = `${project.title} - DavidAdkins.com`;
        if (process.env.NODE_ENV !== "test") {
            ReactGA.send({ hitType: "pageview", page: window.location.pathname });
        }
    });

    return (
        <Card data-testid="project-card">
            <CardActions>
                <Button onClick={() => navigate(-1)}>Back</Button>
            </CardActions>
            <CardActionArea>
                {project.image && <CardMedia image={project.image} title={project.title} sx={{ height: 340 }} />}
                <CardContent>
                    <Typography gutterBottom variant="h2" component="h2">
                        {project.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary" component="div">
                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                            {project.content}
                        </ReactMarkdown>
                    </Typography>
                </CardContent>
            </CardActionArea>
            <CardActions>
                <Button onClick={() => navigate(-1)}>Back</Button>
            </CardActions>
        </Card>
    );
}

export default ProjectCardLarge;
